<template>
  <div class="statistics">
    <div class="row">
      <div class="key">合计数量:</div>
      <div class="val">{{ selectList.length }}</div>
    </div>
    <div class="row">
      <div class="key">订单数:</div>
      <div class="val">{{ statistics.order_detail_count.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">合计金额:</div>
      <div class="val">{{ statistics.total_amount.toFixed(2) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        order_detail_count: 0,
        total_amount: 0,
      }
      this.selectList.forEach(item => {
        total.total_amount += item.total_amount_detail.total_amount - 0
        total.order_detail_count += item.order_detail_count - 0
      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>